export const ACCEPT_TOS_PRIVACY = 'iron/gdpr/ACCEPT_TOS_PRIVACY';
export const SET_TOS_PRIVACY = 'iron/gdpr/SET_TOS_PRIVACY';
export const SHOW_TOS_PRIVACY = 'iron/gdpr/SHOW_TOS_PRIVACY';

export const acceptTOS = () => ({
  type: ACCEPT_TOS_PRIVACY,
});

export const setTOS = (acceptedTOS = false) => ({
  type: SET_TOS_PRIVACY,
  payload: { acceptedTOS },
});

export const showTermsAndPrivacy = (showTerms = false) => ({
  type: SHOW_TOS_PRIVACY,
  payload: { showTerms },
});
